(function() {
	
	var GeomUtils = include("heist.GeomUtils"),
		Rectangle = include("PIXI.Rectangle", false) || include("createjs.Rectangle", false),
		Point = include("PIXI.Point", false) || include("createjs.Point", false),
		Line = include("heist.Line");
	
	if(!Rectangle.prototype.intersects)
	{
		Rectangle.prototype.intersects = function(other)
		{
			var bottom = this.y + this.height,
				right = this.x + this.width,
				otherBottom = other.y + other.height,
				otherRight = other.x + other.width;
			return (this.x <= otherRight &&
				other.x <= right &&
				this.y <= otherBottom &&
				other.y <= bottom);
		};
	}
	
	var CollisionUtils = {};
	
	//Polygon collision math / code borrowed from
	//    http://www.codeproject.com/Articles/15573/2D-Polygon-Collision-Detection
	//with understanding assisted by http://www.metanetsoftware.com/technique/tutorialA.html
	
	//Helper variables
	var _helperP = new Point(),
		_minMaxA = {min:0, max:0},
		_minMaxB = {min:0, max:0};
	
	CollisionUtils.checkPolygonCollision = function(polyA, polyB)
	{
		if(polyA.aabbIsDirty)
			polyA.calcAABB();
		if(polyB.aabbIsDirty)
			polyB.calcAABB();
		//if the axis aligned bounding boxes don't interesct, the polygons definitely don't
		if(!polyA.aabb.intersects(polyB.aabb)) return false;
		var edgesA = polyA.edges;
		var edgeCountA = edgesA.length;
		//don't need to check all 4 sides on a rectangle, since they are parallel and
		//thus on the same axis
		if(polyA.isRectangle)
			edgeCountA /= 2;
		var edgesB = polyB.edges;
		var edgeCountB = edgesB.length;
		if(polyB.isRectangle)
			edgeCountB /= 2;
		_minMaxA.min = 0;
		_minMaxA.max = 0;
		_minMaxB.min = 0;
		_minMaxB.max = 0;
		
		// Loop through all the edges of both polygons
		for (var edgeIndex = 0, len = edgeCountA + edgeCountB; edgeIndex < len; edgeIndex++)
		{
			edge = edgeIndex < edgeCountA ? edgesA[edgeIndex] : edgesB[edgeIndex - edgeCountA];
			
			// Find the axis perpendicular to the current edge
			_helperP.x = -edge.y;
			_helperP.y = edge.x;
			_helperP.normalize();
			
			// Find the projection of the polygon on the current axis
			projectPolygonToAxis(_helperP, polyA, _minMaxA);
			projectPolygonToAxis(_helperP, polyB, _minMaxB);
			
			var minA = _minMaxA.min, maxA = _minMaxA.max, minB = _minMaxB.min, maxB = _minMaxB.max;
			
			// Check if the polygon projections are currently intersecting
			//if (intervalDistance(minMaxA.min, minMaxA.max, minMaxB.min, minMaxB.max) > 0)
			var separation = minA < minB ? minB - maxA : minA - maxB;
			if(separation > 0)
				return false;
		}
		return true;
	};
	
	CollisionUtils.checkLinePolygonCollision = function(line, poly)
	{
		var lineP1X = line.p1.x, lineP1Y = line.p1.y, lineP2X = line.p2.x, lineP2Y = line.p2.y;
		if(poly.contains(lineP1X, lineP1Y))
			return true;
		if(poly.contains(lineP2X, lineP2Y))
			return true;
		
		var points = poly.points;
		var length = points.length;
		var origin = poly.origin;
		
		for(var i = 0, j = length - 1; i < length; j = i++)
		{
			var p1 = points[i], p2 = points[j];
			var polyP1X = p1.x + origin.x, polyP1Y = p1.y + origin.y,
				polyP2X = p2.x + origin.x, polyP2Y = p2.y + origin.y;
			
			if(getLineIntersection(lineP1X, lineP1Y, lineP2X, lineP2Y,
									polyP1X, polyP1Y, polyP2X, polyP2Y))
				return true;
		}
		return false;
	};
	
	//http://stackoverflow.com/questions/563198/how-do-you-detect-where-two-line-segments-intersect#comment19248344_1968345
	function getLineIntersection(p0_x, p0_y, p1_x, p1_y, p2_x, p2_y, p3_x, p3_y, out_intersection)
	{
		var s1_x, s1_y, s2_x, s2_y;
		s1_x = p1_x - p0_x;
		s1_y = p1_y - p0_y;
		s2_x = p3_x - p2_x;
		s2_y = p3_y - p2_y;
		var s, t;
		s = (-s1_y * (p0_x - p2_x) + s1_x * (p0_y - p2_y)) / (-s2_x * s1_y + s1_x * s2_y);
		t = ( s2_x * (p0_y - p2_y) - s2_y * (p0_x - p2_x)) / (-s2_x * s1_y + s1_x * s2_y);
		
		if (s >= 0 && s <= 1 && t >= 0 && t <= 1)
		{
			// Collision detected
			if(out_intersection)
			{
				out_intersection.x = p0_x + (t * s1_x);
				out_intersection.y = p0_y + (t * s1_y);
			}
			return true;
		}
		// No collision
		return false;
	}
	
	// Calculate the projection of a polygon on an axis
	// and returns it as a [min, max] interval
	function projectPolygonToAxis(axis, poly, out_MinMax)
	{
		var points = poly.points;
		var oX = poly.origin.x, oY = poly.origin.y;
		var p = points[0];
		var dotProduct = GeomUtils.dotProduct(p.x + oX, p.y + oY, axis);
		var min = dotProduct;
		var max = dotProduct;
		for (var i = 1, len = points.length; i < len; i++)
		{
			p = points[i];
			dotProduct = GeomUtils.dotProduct(p.x + oX, p.y + oY, axis);
			if (dotProduct < min)
			{
				min = dotProduct;
			}
			else if (dotProduct > max)
			{
				max = dotProduct;
			}
		}
		out_MinMax.min = min;
		out_MinMax.max = max;
	}
	
	// Calculate the distance between [minA, maxA] and [minB, maxB]
	// The distance will be negative if the intervals overlap
	function intervalDistance(minA, maxA, minB, maxB)
	{
		return minA < minB ? minB - maxA : minA - maxB;
	}
	
	namespace('heist').CollisionUtils = CollisionUtils;
}());